import axios from 'axios'
import { 
    CREATE_FEEDBACK_REQUEST,
    CREATE_FEEDBACK_SUCCESS,
    CREATE_FEEDBACK_FAIL,
    GET_FEEDBACK_CONTENT_REQUEST,
    GET_FEEDBACK_CONTENT_SUCCESS,
    GET_FEEDBACK_CONTENT_FAIL,
    GET_CALL_TYPES_REQUEST,
    GET_CALL_TYPES_SUCCESS,
    GET_CALL_TYPES_FAIL,
 } from '../constants/feedbackConstants'

export const createFeedback = (feedbackData) => async (dispatch, getState) => {
    console.log('createFeedback', JSON.stringify(feedbackData))

    try {
        dispatch({ type: CREATE_FEEDBACK_REQUEST })

        const { userLogin: { userInfo } } = getState()

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo.accessToken}` 
            }
        }

        const { data } = await axios.post(
            process.env.REACT_APP_GOLANGAPI + '/api/feedback/' + feedbackData.callType + '/content',
            feedbackData, config)

        dispatch({
            type: CREATE_FEEDBACK_SUCCESS,
            payload: data,
        })

    } catch (error) {
        dispatch({
            type: CREATE_FEEDBACK_FAIL,
            payload: error.response && error.response.data.detail
                ? error.response.data.detail
                : error.message,
        })
    }
}

export const getFeedbackContent = (callType) => async (dispatch, getState) => {
    console.log('getFeedbackContent', callType)
    
    try {
        dispatch({ type: GET_FEEDBACK_CONTENT_REQUEST })

        const { userLogin: { userInfo } } = getState()

        const config = {
            headers: {
                Authorization: `Bearer ${userInfo.accessToken}`
            }
        }
        // Encode callType for safe inclusion in URL
        const encodedCallType = encodeURIComponent(callType);
        const { data } = await axios.get(
            process.env.REACT_APP_GOLANGAPI + `/api/feedback/${encodedCallType}/content`, config)

        dispatch({
            type: GET_FEEDBACK_CONTENT_SUCCESS,
            payload: data, // Assuming the API returns an object like { content: "..." }
        })

    } catch (error) {
        dispatch({
            type: GET_FEEDBACK_CONTENT_FAIL,
            payload: error.response && error.response.data.detail
                ? error.response.data.detail
                : error.message,
        })
    }
}

export const getAvailableCallTypes = () => async (dispatch, getState) => {
    try {
        dispatch({ type: GET_CALL_TYPES_REQUEST })

        const { userLogin: { userInfo } } = getState() // Assuming auth might be needed

        const config = {
            headers: {
                Authorization: `Bearer ${userInfo.accessToken}` // If endpoint is protected
            }
        }

        const { data } = await axios.get(process.env.REACT_APP_GOLANGAPI + '/api/feedback/call-types', config) 

        dispatch({
            type: GET_CALL_TYPES_SUCCESS,
            payload: data, // Assuming API returns an array of strings: ["Type1", "Type2"]
        })

    } catch (error) {
        dispatch({
            type: GET_CALL_TYPES_FAIL,
            payload: error.response && error.response.data.detail
                ? error.response.data.detail
                : error.message,
        })
    }
} 